// 表单验证
export const VERIFY_MUST_CHECKED = 'VERIFY_MUST_CHECKED' // 必须选中的checkbox用
export const VERIFY_MUST_SELECTED = 'VERIFY_MUST_SELECTED' // 下拉菜单
export const VERIFY_CELLPHONE = 'VERIFY_CELLPHONE'
export const VERIFY_CHN_NAME = 'VERIFY_CHN_NAME'
export const VERIFY_ID_CARD_NUM = 'VERIFY_ID_CARD_NUM'
export const VERIFY_BANKCARD_NUM = 'VERIFY_BANKCARD_NUM'

export const VERIFY_LOGIN_PASSWORD = 'VERIFY_LOGIN_PASSWORD'
export const VERIFY_LOGIN_VERIFICATION_CODE = 'VERIFY_LOGIN_VERIFICATION_CODE'
export const VERIFY_REGISTER_PASSWORD = 'VERIFY_REGISTER_PASSWORD'
// export const VALIDATE_SMS_VERIFICATION_CODE = 'VALIDATE_SMS_VERIFICATION_CODE'
export const VERIFY_PASSWORD_VALID = 'VERIFY_PASSWORD_VALID' // 验证密码，用于修改密码时候旧密码的验证
export const VERIFY_ENTERPRISE_ORGANIZING_NUMBER = 'VERIFY_ENTERPRISE_ORGANIZING_NUMBER' // 组织机构代码证号
export const VERIFY_SOCIAL_CREDIT_CODE = 'VERIFY_SOCIAL_CREDIT_CODE' // 社会信用代码号
export const VERIFY_ENTERPRISE_NUMBER = 'VERIFY_ENTERPRISE_NUMBER' // 营业执照号



// WEBPACK FOOTER //
// ./src/vuex/types/form.js